import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { SearchSelect } from '@/components/po/SearchSelect';
import { fmtQty, prApi } from '@/services/prApi';

/** FG filter of the requisitions list — every FG on a requisition with its total still to order. */
export const PrFgFilter = ({ value, onChange }) => {
  const [fgs, setFgs] = useState(null);
  useEffect(() => { prApi.fgSummary().then(setFgs).catch(() => setFgs([])); }, []);
  const cur = (fgs || []).find((f) => f.fg_name === value);
  const options = (fgs || []).map((f) => ({ value: f.fg_name, label: `${f.fg_name} · ${f.design_name || ''}`,
    sub: `${[f.fg_shade, f.fg_size, f.fg_description].filter(Boolean).join(' · ')} — ${fmtQty(f.balance_qty)} ${f.unit} to order · ${f.pr_count} line${f.pr_count === 1 ? '' : 's'}` }));
  return (
    <div className="flex min-w-[260px] items-center gap-1" data-testid="pr-fg-filter">
      <div className="min-w-0 flex-1">
        <SearchSelect value={value} options={options} onChange={onChange} loading={!fgs} placeholder="All FGs" searchPlaceholder="Search FG, design, shade…"
          empty="No FG on any requisition yet" testId="pr-fg-filter-select" />
      </div>
      {cur && <span className="whitespace-nowrap rounded-md bg-amber-100 px-2 py-1 text-xs font-semibold text-amber-800" data-testid="pr-fg-filter-pending">
        {fmtQty(cur.balance_qty)} {cur.unit} to order</span>}
      {value && <button type="button" onClick={() => onChange('')} className="rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-700" data-testid="pr-fg-filter-clear"><X className="h-4 w-4" /></button>}
    </div>
  );
};

export default PrFgFilter;
